import { Box, HStack, Icon, VStack } from "@chakra-ui/react";
import CDS from "design-system";
import { FiAlertTriangle } from "react-icons/fi";
import { ListIssuesByAction } from "features/Issues/Components/ListIssues/ListIssuesByAction";
import { PrefixId } from "features/Resources/Shared/models";

interface FailedActionBannerProps {
  prefixId: PrefixId;
  errorMessage?: string;
  /** The action noun used in the lead sentence — "email" / "message" / "meeting". */
  actionNoun: string;
}

export default function FailedActionBanner({
  prefixId, errorMessage, actionNoun,
}: FailedActionBannerProps) {
  return (
    <VStack
      align="stretch"
      spacing={3}
      p={4}
      mb={4}
      bg="red.50"
      borderWidth={1}
      borderColor="red.200"
      borderRadius="md"
    >
      <HStack align="flex-start" spacing={3}>
        <Icon as={FiAlertTriangle} color="red.500" boxSize={5} mt={0.5} aria-hidden />
        <VStack align="stretch" spacing={1} flex={1}>
          <CDS.Text14 fontWeight="semibold" color="red.800">
            This {actionNoun} failed to send.
          </CDS.Text14>
          {errorMessage ? (
            <Box
              as="pre"
              fontSize="xs"
              color="red.900"
              bg="white"
              borderWidth={1}
              borderColor="red.100"
              borderRadius="sm"
              p={2}
              whiteSpace="pre-wrap"
              wordBreak="break-word"
              fontFamily="mono"
            >
              {errorMessage}
            </Box>
          ) : (
            <CDS.Text12 color="red.700" fontStyle="italic">
              No error detail was captured. Check the audit log or try Send Now to surface the underlying error.
            </CDS.Text12>
          )}
        </VStack>
      </HStack>
      <ListIssuesByAction prefixId={prefixId} mt={0} />
    </VStack>
  );
}
